import React from 'react'

export default (
    <>
        <div>
            <h1>Terms of use</h1>
        </div>
        <div>
            <p>
                <strong>About these Terms of use</strong>
            </p>
            <p>
                We ask that you carefully read these terms before using our website. These terms of use tell you about
                the way you can use our website. By continuing to browse on our website, you accept these terms and
                conditions. If you do not accept these terms of this policy, you must not use our site.
            </p>
        </div>
        <div>
            <p>
                <strong>Your Personal information</strong>
            </p>
            <p>
                We process all of the personal data you give to us on our website in accordance with the terms of our
                Privacy Policy. Please ensure that all of the information you give to us on our website including any
                username and password is kept safe, secure and confidential.
            </p>
        </div>
        <div>
            <p>
                <strong>The information on our website</strong>
            </p>
            <p>
                We do our best to ensure that our website operates properly at all times, but we make no warranties as
                to the availability or accessibility of our website, and (except as set out here) we will not be liable
                for any damages, loss, costs or expenses incurred by you as a result of any lack of availability or
                accessibility of our website. If our prices are displayed incorrectly, we reserve the right to rectify
                the prices and not sell you the product at the price you originally saw on our website.
            </p>
        </div>
        <div>
            <p>
                <strong>Links and sharing</strong>
            </p>
            <p>
                Any links or opportunities to share (via social media, blogs, and similar sites and communication
                services) on our website are provided solely for your use and convenience. The link does not represent
                any endorsement or recommendation by us and does not mean that we have any association with the linked
                website. We are not responsible for the content of any websites that are linked to or from our website
                or for the legal consequences of your entering into any contracts with the third parties that provide
                these linked websites and we do not accept any liability for any loss, damage, expense, costs or
                liability whatsoever incurred by you as a result.
            </p>
            <p>
                Please note that if you do share content onto other platforms, there may be separate terms and
                conditions connected to the organisation that allows you to share. Please check the terms and conditions
                of any site you intend to share to. Some terms and conditions may prohibit you from sharing our content.
            </p>
            <p>
                We will not be liable for any loss, damage, expense, costs, delays or other liability whatsoever
                (including without limitation any financial losses such as loss of profit) which you may incur as a
                result of any event beyond our reasonable control (including without limitation any failure of
                transmission, communication, computer or other facilities or your inability to access the website for
                any reason or any failure, error or delay in the sending or receiving of any)
            </p>
        </div>
        <div>
            <p>
                <strong>Copyright</strong>
            </p>
            <p>
                The content of all parts of the website belongs to IKEA. This includes copyright in all of the text,
                descriptions and images. It also includes trademarks in our name and logos.
            </p>
            <p>
                You may download to a local hard disk and print extracts from our website for your personal use. You may
                also recopy downloaded extracts to others provided you do not do so for profit.
            </p>
            <p>
                Reproduction of part or all of the contents in any form is prohibited unless for personal use. None of
                the content of our website may be copied or otherwise incorporated into or stored in any other web site,
                electronic retrieval system, publication or other work in any form (whether hard copy, electronic or
                other).
            </p>
            <p>
                If you want to use any of our content for any purpose other than as set out above (which includes
                framing the website) you must first contact us and obtain our permission.
            </p>
        </div>
        <div>
            <p>
                <strong>Make sure you are up to date</strong>
            </p>
            <p>
                We reserve the right to change the terms on which our website and products are offered at any time. Any
                changes to our legal terms and conditions will take effect immediately when they are placed on our
                website and will apply to all future use of our website. You should regularly check the General Terms
                and Conditions and our policies posted on our website as they may have changed since your last visit.
            </p>
        </div>
        <div>
            <p>
                <strong>What you cannot do on our website</strong>
            </p>
            <p>
                When using our website you cannot: (1) interfere or disable any security related features of the site or
                features that prevent or restrict use or copying of the content accessible via the site; (2) give any
                false information in your account details; (3) take another person’s identity without that person’s
                permission or misrepresent you are acting on behalf of a person, entity or organisation; (4) use the
                site if we have suspended or banned you from using it; (5) send junk, spam or repetitive messages; (6)
                engage in any illegal or unlawful conduct; (7) modify, interfere, intercept, disrupt or hack the site;
                (8) misuse the site by knowingly introducing viruses, Trojans, worms, logic bombs or other similar
                material or by undertaking any other action which would harm the site, any site user’s equipment or have
                a detrimental impact on any site user’s experience of using the site; (9) collect any data from the site
                other than in accordance with these Terms of Use; (10) submit or contribute any content that is abusive,
                threatening, obscene, untrue, shocking or offensive; (11) abuse, harm or bully another site user, member
                of our staff or person; (12) submit or contribute any User Content without the permission of the content
                owner or otherwise infringe the copyright, trademark or other rights of third parties; or (13) submit or
                contribute any information or commentary about another person which is untrue, private, confidential or
                defamatory (including personally accusing another person of unproven criminality or serious wrongdoing
                which could damage their reputation in the eyes of anyone reading your comment).
            </p>
            <p>
                If you breach any of these Terms of Use we may prevent you from using this website on a permanent or
                temporary basis. We can take other action as well including but not limited to reporting you to the
                police or other law enforcement body, issue a warning or take legal action against you and pursue any
                costs we incur as a result of doing this.
            </p>
        </div>
        <div>
            <p>
                <strong>Governing Law</strong>
            </p>
            <p>
                If you are a consumer, please note that these terms of use, their subject matter and formation, are
                governed by English law. You and we both agree to that the courts of England and Wales will have
                non-exclusive jurisdiction. However, if you are a resident of Northern Ireland you may also bring
                proceedings in Northern Ireland, and if you are resident of Scotland, you may also bring proceedings in
                Scotland.
            </p>
            <p>
                If you are a business, these terms of use, their subject matter and formation (and any non-contractual
                disputes or claims) are governed by English law. We both agree to the exclusive jurisdiction of the
                courts of England and Wales.
            </p>
        </div>
        <div>
            <p>
                <strong>Any questions?</strong>
            </p>
            <p>If you have any questions about anything on this website you can contact us.</p>
            <p>Date updated: 05/04/2018</p>
        </div>
    </>
)
